export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/restrictions/state.js